const OfferSpendByOfferListTableLangKey = [
	'column_offer_id',
	'column_offer',
	'column_offer_in_group',
	'column_country',
	'column_amount',
	'column_date',
] as const

type IOfferSpendByOfferListTableLangKey = typeof OfferSpendByOfferListTableLangKey[number]

export type IOfferSpendByOfferListTableLang = {
	offer_spend_by_offer_list_table: Record<IOfferSpendByOfferListTableLangKey, string>
}

const langEntries = OfferSpendByOfferListTableLangKey.map(
	(key: IOfferSpendByOfferListTableLangKey) => [key, `offer_spend_by_offer_list_table.${key}`]
)

const langObj: Record<IOfferSpendByOfferListTableLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_BY_OFFER_LIST_TABLE_LANG_KEY: IOfferSpendByOfferListTableLang = {
	offer_spend_by_offer_list_table: langObj
}
